import { useReducer } from "react";
import { useIntl } from "react-intl";

const capturedAtReducer = (state: Date): Date => state;

const getDataCaptureTimestampParts = (date: Date) => {
  const dateLabel = date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
  const timeLabel = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
  });
  const timezoneLabel =
    new Intl.DateTimeFormat("en-US", { timeZoneName: "short" })
      .formatToParts(date)
      .find((part) => part.type === "timeZoneName")?.value ?? "";

  return { dateLabel, timeLabel, timezoneLabel };
};

export const AiDataCaptureCaption = () => {
  const intl = useIntl();
  const [capturedAt] = useReducer(capturedAtReducer, null, () => new Date());
  const { dateLabel, timeLabel, timezoneLabel } =
    getDataCaptureTimestampParts(capturedAt);

  return (
    <p className="tcw-data-caption">
      {intl.formatMessage(
        { id: "app.toolboxChat.dataCaptureTimestamp" },
        { date: dateLabel, time: timeLabel, timezone: timezoneLabel },
      )}
    </p>
  );
};
